import { useEffect, useState } from 'react';
import './ordersummary.scss';
import { useCart } from '../../context/CartContext';
import { useNavigate, useParams } from 'react-router-dom';
import ProductsSummary from '../ProductsSummary/ProductsSummary';
import { billingData, Coupon } from '../../interface/interfaces';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import { useNotification } from '../../context/NotificationContext';
import { checkoutCart, getCoupon } from '../../api/requests';
// import { billingData } from '../../interface/interfaces'
// import { getBilling } from '../../api/requests'

type Props = {
 billingData: billingData | null;
 deliveryFee: number;
 loader: boolean;
};

const OrderSummary = ({
 billingData,
 deliveryFee,
 loader,
}: Props) => {
 const navigate = useNavigate();
 const { cartData } = useCart();
 const { notify } = useNotification();
 const { coupon_id } = useParams();
 const [isLoading, setIsLoading] = useState(false);
 const [summaryLoading, setSummaryLoading] = useState(false);
 const [orderSummary, setOrderSummary] = useState({
  cartTotal: 0,
  shippingfee: 0,
  vat: 0,
  coupondiscount: 0,
  orderTotal: 0,
  currency_data: {
   currency_symbol: '₦',
  },
 });

 const [couponData, setCouponData] = useState<Coupon | null>(null);

 function getDiscountAmount(cartTotal: number) {
  if (couponData) {
   let amt = cartTotal * (couponData.discount_percentage / 100);
   return amt;
  } else {
   return 0;
  }
 }

 const calculateSummary = () => {
  let cartTotal = 0;
  let orderTotal = 0;

  cartData.forEach((data) => {
   cartTotal += data.totalAmount;
  });

  let discountAmt = getDiscountAmount(cartTotal);

  orderTotal =
   cartTotal + deliveryFee + orderSummary.vat - discountAmt;

  setOrderSummary((prev) => {
   return {
    ...prev,
    cartTotal: cartTotal,
    orderTotal: orderTotal,
    shippingfee: deliveryFee,
    coupondiscount: discountAmt,
   };
  });
 };

 useEffect(() => {
  (async () => {
   if (coupon_id && coupon_id !== '') {
    try {
     setSummaryLoading(true);

     let cdata = await getCoupon(coupon_id);

     setCouponData(cdata);
    } catch (error: any) {
     notify.error('Error getting coupon data!');
    } finally {
     setSummaryLoading(false);
    }
   }
  })();
  // eslint-disable-next-line
 }, [coupon_id]);

 useEffect(() => {
  calculateSummary();

  // eslint-disable-next-line
 }, [cartData, billingData, deliveryFee, couponData]);

 const goTo = (page: string) => {
  navigate(page);
 };

 const handlePlaceOrder = async () => {
  if (!billingData) {
   notify.error('Please select an address to continue');
   return;
  }

  try {
   setIsLoading(true);

   let body = {
    billing_information: billingData.id,
    coupon: couponData ? couponData.id : '',
    payment_method: 'Card',
   };

   let resp = await checkoutCart(body);

   if (resp) {
    window.location = resp.transaction_details.authorization_url;
   }
  } catch (error: any) {
   notify.error(error.message);
  } finally {
   setIsLoading(false);
  }
 };

 return (
  <div className="ordersummary">
   <div className="orderbox">
    <div className="title">Order summary</div>

    {(summaryLoading || loader) && (
     <div className="spinnerpack">
      <div className="bigspinner"></div>
     </div>
    )}

    {!summaryLoading && !loader && (
     <>
      <div className="orderinfo animate__animated animate__fadeIn animate__fast">
       <ProductsSummary></ProductsSummary>

       <div className="eachinfo">
        <div className="info">Sub Total</div>
        <div className="value">
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.cartTotal.toLocaleString()}
        </div>
       </div>

       <div className="eachinfo">
        <div className="info">Shipping</div>
        <div className="value">
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.shippingfee.toLocaleString()}
        </div>
       </div>

       <div className="eachinfo">
        <div className="info">VAT</div>
        <div className="value">
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.vat.toLocaleString()}
        </div>
       </div>

       <div className="eachinfo discount">
        <div className="info">Coupon discount</div>
        <div className="value">
         - &nbsp;
         {orderSummary.currency_data.currency_symbol}
         {orderSummary.coupondiscount.toLocaleString()}
        </div>
       </div>
      </div>

      <hr className="line"></hr>

      <div className="eachinfo totalbal">
       <div className="info">Total</div>
       <div className="value">
        {orderSummary.currency_data.currency_symbol}
        {orderSummary.orderTotal.toLocaleString()}
       </div>
      </div>

      <div className="btn-pack">
       {cartData.length > 0 && (
        <LoaderBtn
         className={'checkout-btn'}
         clickFunction={handlePlaceOrder}
         text={'Place Order'}
         isLoading={isLoading}
         thickness={3}
        ></LoaderBtn>
       )}

       {cartData.length <= 0 && (
        <button
         className="checkout-btn"
         onClick={() => goTo('/products')}
        >
         Continue Shooping
        </button>
       )}
      </div>
     </>
    )}
   </div>
  </div>
 );
};

export default OrderSummary;
